<template>
  <div>
    <loading :loading="loading"></loading>
  </div>
</template>

<script>
  import DataSource from "@/data/DataSource";
  import Loading from "../layout/Loading";

  //Don't import error alert component in this item. ErrorAlert item uses this component => Cyclic dependency will occur

  export default {
    name: "SendEmailItem",
    components: { Loading },
    props: {
      sendMailEvent: {
        type: Boolean,
        required: true,
        default: false,
      },

      sendEmailRequest: {
        type: Object,
        required: true
      },

      sendEmailSilently: {
        type: Boolean,
        default: false
      },
    },

    methods: {
      sendMail() {
        if (!this.sendEmailSilently) {
          this.loading = true;
        }
        DataSource.sendMail(this.sendEmailRequest)
          .then(emailSentRes => {
            this.loading = false;
            this.$emit("sendMailEvent", emailSentRes);
          })
      }
    },
    data: () => ({
      loading: false,
    }),

    watch: {
      sendMailEvent() {
        if (this.sendMailEvent) {
          this.sendMail();
        }
      }
    }
  };
</script>

<style scoped>

</style>